/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions
import { displayScreen } from 'redux/actions/screen_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import RewardsIndicator from 'components/shared/rewardsindicator/rewardsindicator';



/* ========== ~~~~~~~~~~ REWARDS INDICATOR : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ rewards, sessionStatus }, { contentId }) => ({
    userGeo: sessionStatus.userGeo,
    numberOfRewardsEarned: rewards.status.numberOfRewardsEarned,
    pointsEarned: rewards.status.pointsEarned,
    rewardEarnedPhase: rewards.status.rewardEarnedPhase,
    redeemAfter: rewards.settings.redeemAfter,
    showExpandedMessage: rewards.status.showExpandedMessage,
    monetaryValue: rewards.settings.monetaryValue,
    rewardsEnabled: rewards.settings.enabled,
    rewardsPermitted: rewards.status.rewardsPermitted
});

const mapDispatchToProps = dispatch => ({
    displayScreen: (screen) => dispatch(displayScreen(screen))
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RewardsIndicator);
